export const locale = {
    'CONSISTENCY' : {
        'TITLE' : 'Transfer orders',
        'MESSAGE' : 'The order has not been agreed with the Customer. It is necessary to coordinate the order before handing it over to the contractor.',
        'CONFIRM' : 'Agreed',
        'DECLINE' : 'Cancel',
    },
};
